//component entry file
import MorningstarAward from "./components/MorningstarAward/MorningstarAward.vue";

export default MorningstarAward;